import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://www.aleimanpaper.org";

/*
 * Sets the document title and a per-route canonical URL.
 *
 * Two reasons this is a hook rather than assignments in render:
 *
 * 1. Titles were previously set during render, which is a side effect in the
 *    render phase.
 * 2. The canonical URL has to change per route. A single static canonical in
 *    index.html would tell search engines that every issue page is really the
 *    homepage — worse than having none at all. It also collapses the duplicate
 *    www/apex addresses onto one canonical host.
 */
export default function usePageMeta(title) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
    }

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", SITE_ORIGIN + pathname);
  }, [title, pathname]);
}
